module.exports = __webpack_public_path__ + "assets/a61c06a6b7056552feb7cdd2d5e16053.mp3";